module.exports = __webpack_public_path__ + "static/img/icon2-12.9b09a049.png";